import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thanks-state',
  templateUrl: './thanks-state.component.html',
  styleUrls: ['./thanks-state.component.scss']
})
export class ThanksStateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
